module.exports = __webpack_public_path__ + "static/media/warn.76413743.svg";